import { EventStatus } from '../../../constants/eventStatus';
import { getEventDates } from '../../../selectors/event/getEventDates';

export const getFirstDayWithAvailableSessions = (
    dates: ReturnType<typeof getEventDates>[string],
) => {
    const firstAvailableDay = dates.find(
        (date) => date.availability !== EventStatus.soldOut,
    );

    return firstAvailableDay;
};
